import { useCallback, useContext, useEffect } from 'react';
import { message as Message } from 'antd';
import FrameworkContext from '../framework/FrameworkContext';
import { loadUserInfoFn } from '../modules';
import { EUserInfoLoadState } from '../types';


function useUserInfo() {
  const {state, dispatch} = useContext(FrameworkContext);
  const { userInfo, userInfoLoadState } = state;

  const loadUserInfo = useCallback(() => {
    if (userInfoLoadState === EUserInfoLoadState.LoadFail
      || userInfoLoadState === EUserInfoLoadState.Unload) {
        dispatch({
          payload: {
            userInfoLoadState: EUserInfoLoadState.Loading
          }
        });

        loadUserInfoFn().then(({data}) => {
          dispatch({
            payload: {
              userInfo: data || {},
              userInfoLoadState: EUserInfoLoadState.Loaded
            }
          });
        }).catch(({ message }) => {
          dispatch({
            payload: {
              userInfoLoadState: EUserInfoLoadState.LoadFail
            }
          });
          message && Message.info(message);
        })
    }
  }, [dispatch, userInfoLoadState]);

  useEffect(() => {
    loadUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    userInfo,
    userInfoLoaded: userInfoLoadState === EUserInfoLoadState.Loaded,
  }
}

export default useUserInfo
